import { useContext } from 'react';
import { OneLPSsdkParamsContext } from '../onelps-sdk-params-context';
import { ENVIRONMENTS } from '../constants/environments';

export function getAssetUrl() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const assetUrl = ENVIRONMENT === ENVIRONMENTS.DEVELOPMENT
		? ''
		: onelpsParams.cdnUrlPrefix;

	return  assetUrl;
}
